<template>
  <div>
    <div v-if="show" class="intercom">
      <div class="intercom-box">
        <div class="title">{{ title }}</div>
        <el-space>
          <el-button type="primary" size="small" :loading="answerLoading == 1"
            @click="sendAudioVideo2(2)">接听</el-button>
          <el-button type="danger" size="small" :loading="answerLoading == 2"
            @click="sendAudioVideo2(0), 'go-video'">挂断</el-button>
        </el-space>
      </div>
    </div>
    <div class="video-box" v-if="dialogVisible" :style="videoBoxStyle">
      <div class="center">
        <ul @mousedown="startDrag">
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <div class="video" id="go-video">
          <div class="tips" v-if="registerErrorText">{{ registerErrorText }}</div>
        </div>
        <!-- <div class="user-video" id="user-video"></div> -->
        <div class="title">{{ title }}</div>
        <el-button type="danger" size="small" :loading="answerLoading == 2" @click="sendAudioVideo2(0)">挂断</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global YFHCSdk */
export default {
  name: '',
  data() {
    return {
      show: false,
      dialogVisible: false,
      title: '',
      sdk: null,
      curData: null, //当前数据
      sn: '',
      answerLoading: 0,
      incomingCallQueue: [], // 保存来电队列
      currentSession: null, // 保存当前会话
      closeMissedTimer: null, // 来电结束后延迟关弹窗的定时器
      registerErrorText: '',  //注册失败提示
      videoBoxStyle: {
        position: 'fixed',
        top: '20vh',
        left: '50%',
        zIndex: 8,
        width: '500px',
        padding: '24px',
        marginLeft: '-280px',
        backgroundColor: '#fff',
        borderRadius: '16px',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.urtcAuth()
    })
  },
  beforeUnmount() {
    if (this.closeMissedTimer) {
      clearTimeout(this.closeMissedTimer)
      this.closeMissedTimer = null
    }
    // 组件销毁前销毁狮虎云SDK单例（unregister 不会重置单例，
    // 会导致重挂载后回调仍绑定在旧组件上、来电队列永远为空）
    if (this.sdk) {
      this.sdk.destroy()
      this.sdk = null
    }
  },
  methods: {
    urtcAuth() {
      const options = {
        ringingPath: "../../shy/ringing.mp3", // 铃音文件存放路径 不传默认无来电铃音用户可自定义
        volume: 100, //设置通话音量 不传默认100原声采集, 可取值范围[0-1000]
        log: true, // 是否开启调试日志，生产环境建议关闭
        logLevel: 0, // 日志等级 0:debug 1:info 2:warn 3:error 4:none
        supportQueue: true, // 是否开启来电队列 (v2.2.0版本及以上支持)
        onLocalVideo: '', // 本地视频播放容器id (对于弹窗接听方式, 可以在点击接听弹窗后通过sdk.setOnLocalVideo()进行赋值)
        onRemoteVideo: 'go-video', // 远端视频播放容器id 同上
        // 连接断开回调
        onDisconnected: (cause, err) => {
          // $('#output-lbl').text(cause);
          // this.$message({
          //   type: 'warning',
          //   message: cause,
          // })
        },
        // 注册成功回调
        onRegistered: (data) => {
          // $('#login-btn, #server-address, #name, #exten, #password').attr('disabled', 'disabled');
          // $('#logout-btn,#call-to,#call-btn').removeAttr('disabled');
          // $('#call-to').focus();
          // $('#output-lbl').text(data);

        },
        // 注销回调
        onUnregistered: (cause) => {
          // $('#login-btn, #server-address, #name, #exten, #password').removeAttr('disabled');
          // $('#output-lbl').text(cause);
          // this.$message({
          //   type: 'warning',
          //   message: cause,
          // })
        },
        // 注册失败回调
        onRegistrationFailed: (cause) => {
          // $('#output-lbl').text(cause);
          // this.$message({
          //   type: 'warning',
          //   message: cause,
          // })
          this.registerErrorText = '注册失败提示：在地址栏输入：chrome://flags/#unsafely-treat-insecure-origin-as-secure将Insecure origins treated as secure 选择设置为 Enabled，并在输入框中输入不安全源(HTTP)的云岗亭地址和端口号，多个地址以英文逗号分隔。Relaunch 后生效。'
        },
        // 呼叫失败回调（可在此方法中进行弹窗提示错误信息，cause是错误描述）
        onFailed: (cause, error) => {
          // $('#call-btn,#call-to').removeAttr('disabled');
          // $('#output-lbl').text(cause.message);
          // this.$message({
          //   type: 'warning',
          //   message: cause.message,
          // })
        },
        // 呼叫回调（呼叫成功回调）
        onOutGoingCall: (data) => {
          // $('#hangup-btn').removeAttr('disabled');
          // $('#call-btn,#call-to').attr('disabled', 'disabled');
          // var to = $('#call-to').val();
          // $('#output-lbl').text('请稍等,正在呼叫 ' + to + '...');
          this.$message({
            type: 'warning',
            message: '请稍等,正在呼叫',
          })
        },
        // 来电回调（仅记录日志；来电弹窗以业务MQTT推送为准，队列由onCallQueueChanged维护）
        onInComingCall: (data) => {
          console.log('狮虎云来电:', data)
        },
        // 来电队列变化回调
        onCallQueueChanged: (queue) => {
          console.log('来电队列变化:', queue)
          this.incomingCallQueue = queue || []
          // 来电弹窗开着但队列里已无等待中的来电：
          // 说明来电已超时/对方挂断/被其他端接听，延迟确认后关闭弹窗并告知后台
          if (this.show && !this.hasRingingCall()) {
            this.scheduleCloseMissedCall()
          }
        },
        // 当前会话变化回调
        onCurrentSessionChanged: (session) => {
          console.log('当前会话变化:', session)
          this.currentSession = session
        },
        // 当呼出超时未被接听或来电超时未接听都会触发该回调，sdk默认超时时间45秒固定值
        onMissedCall: (data) => {
          console.log('来电超时未接听:', data)
          if (this.show) {
            this.scheduleCloseMissedCall()
          }
        },
        // 接通后回调
        onCallAccepted: (data) => {
          // $('#hangup-btn').removeAttr('disabled');
          // $('#call-btn,#call-to,#answer-btn').attr('disabled', 'disabled');
          //获取主叫号码
          // var callerNumber = data.uid;
          // //获取主叫名称
          // var callerName = data.localDisplayName;
          // //获取被叫号码
          // var calleeNumber = data.rid;
          // //获取被叫名称
          // var calleeName = data.remoteDisplayName;
          // $('#output-lbl').text('正在与' + calleeName + '通话中....');
          this.$message({
            type: 'success',
            message: '正在通话中',
          })
        },
        // 挂断后执行
        onCallTerminated: (msg) => {
          console.log('通话结束:', msg)
          // 通话中（视频弹窗打开）对方挂断/异常断开/接听失败：
          // 主动挂断时 dialogVisible 已提前置为 false，不会重复上报
          if (this.dialogVisible) {
            this.endCallLocal()
          }
        }
      };
      // 实例化sdk
      this.sdk = YFHCSdk.createShyPhone(options);
      let userForm = {
        localUser: process.env.VUE_APP_SHY_USER,
        password: process.env.VUE_APP_SHY_PASSWORD,
        displayName: '', //$('#name').val(), 
      }
      this.sdk.register(userForm);
    },
    open(title, data, type) {
      this.title = title
      this.sn = data.device_id
      this.curData = data
      if (type == 1) {
        this.sendAudioVideo2(1)
      } else {
        setTimeout(() => {
          this.show = true
        }, 800)
      }
    },
    // status 1呼叫  2接听 0挂断
    async sendAudioVideo2(status) {
      console.log('通话操作:', status, '来电队列:', this.incomingCallQueue, '当前会话:', this.currentSession)
      if (status == 1) {
        this.show = false
        this.dialogVisible = true
        this.sdk?.call(this.sn);
      } else if (status == 2) {
        // 接听 - 从来电队列获取 callId
        // SDK 的 Invite 消息可能晚于业务MQTT推送到达，短暂重试等待
        let incomingCall = null
        for (let i = 0; i < 4; i++) {
          incomingCall = this.findIncomingCall() // status=4 表示来电中
          if (incomingCall && incomingCall.callId) break
          if (i < 3) await new Promise(resolve => setTimeout(resolve, 300))
        }
        const callId = incomingCall && incomingCall.callId
        console.log('接听 - 找到的来电:', incomingCall, 'callId:', callId)
        this.show = false
        if (!callId) {
          this.$message.warning('来电已结束或已超时')
          console.error('来电队列详情:', JSON.stringify(this.incomingCallQueue))
          this.endCallLocal()
          return
        }
        this.dialogVisible = true
        // 确保 callId 是字符串类型
        this.sdk?.answer('video', String(callId))
        this.$emit('callingAccept', this.curData, 2)
      } else if (status == 0) {
        // 挂断 - 优先使用当前会话，如果没有则从队列获取
        let callId = this.currentSession && this.currentSession.callId
        let callSource = '当前会话'
        if (!callId) {
          if (this.incomingCallQueue.length > 0) {
            const activeCall = this.incomingCallQueue.find(call => call.status === 3 || call.status === 4)
            callId = activeCall && activeCall.callId
            callSource = '来电队列'
          }
        }
        console.log('挂断 - callId:', callId, '来源:', callSource)
        this.dialogVisible = false
        this.show = false
        if (!callId) {
          this.$message.warning('没有活跃的通话可挂断')
          this.endCallLocal()
          return
        }
        this.sdk?.hangup(callId)
        this.$emit('callingAccept', this.curData, 3)
      }
    },
    // 队列中是否存在等待接听的来电（SDK 状态 4=RINGING）
    hasRingingCall() {
      return this.incomingCallQueue.some(call => call.status === 4)
    },
    // 查找当前来电：优先匹配本次推送的设备号（SDK通知对其他账号也会触发），
    // 匹配不到时回退到队列中第一个等待中的来电
    findIncomingCall() {
      return this.incomingCallQueue.find(
        call => call.status === 4 && String(call.rid) === String(this.sn)
      ) || this.incomingCallQueue.find(call => call.status === 4)
    },
    // 延迟确认后再关弹窗：SDK 的 Invite 可能晚于业务推送到达，避免误关
    scheduleCloseMissedCall() {
      if (this.closeMissedTimer) {
        clearTimeout(this.closeMissedTimer)
      }
      this.closeMissedTimer = setTimeout(() => {
        this.closeMissedTimer = null
        if (this.show && !this.hasRingingCall()) {
          console.log('来电已结束（超时/对方挂断/被其他端接听），自动关闭弹窗')
          this.$message.warning('来电已结束或已超时')
          this.endCallLocal()
        }
      }, 2000)
    },
    // 本地结束通话：关闭弹窗并告知后台（talk_status 3=挂断/结束）
    endCallLocal() {
      this.show = false
      this.dialogVisible = false
      this.$emit('callingAccept', this.curData, 3)
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;

      const videoBox = this.$el.querySelector('.video-box');
      this.offsetX = e.clientX - videoBox.getBoundingClientRect().left;
      this.offsetY = e.clientY - videoBox.getBoundingClientRect().top;

      document.addEventListener('mousemove', this.onDragging);
      document.addEventListener('mouseup', this.stopDrag);
    },
    onDragging(e) {
      if (!this.isDragging) return;
      this.videoBoxStyle.left = `${e.clientX - this.offsetX}px`;
      this.videoBoxStyle.top = `${e.clientY - this.offsetY}px`;
      this.videoBoxStyle.marginLeft = '0px'; // Clear margin-left when dragging
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onDragging);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.el-dialog__header) {
  display: none;
}

.intercom-box {
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -120px;
  width: 240px;
  padding: 30px;
  background-color: #fff;
  text-align: center;
  box-sizing: border-box;
  z-index: 1;

  .title {
    padding-bottom: 20px;
    font-weight: bold;
  }
}

.video-box {
  position: fixed;
  top: 20vh;
  left: 45%;
  z-index: 8;
  width: 450px;
  padding: 24px;
  margin-left: -200px;
  background-color: #fff;
  border-radius: 16px;
  box-sizing: border-box;

  ul {
    margin-bottom: 12px;
    cursor: all-scroll;
  }

  li {
    width: 40px;
    height: 4px;
    background-color: #bbb;
    margin: 0 auto 3px;
  }

  .video {
    width: 450px;
    height: 450px;
    margin: 0 auto 12px;
    border-radius: 8px;
    overflow: hidden;
  }

  .user-video {
    width: 150px;
    height: 150px;
    position: absolute;
    right: 30px;
    top: 30px;
  }

  .title {
    padding: 12px 0;
  }

  .tips {
    margin-top: 100px;
    font-size: 14px;

  }
}
</style>